import { jsx as t } from "react/jsx-runtime";
import { Container as m, Image as e, modalStyle as a } from "./style.js";
import { useModal as n } from "../Modal/context.js";
function d(o) {
  return /* @__PURE__ */ t(m, { "data-testid": "zoom-modal", children: /* @__PURE__ */ t(e, { ...o }) });
}
function u() {
  const { showModal: o } = n();
  return (r) => o(/* @__PURE__ */ t(d, { ...r }), {
    style: a
  });
}
export {
  d as ZoomModal,
  u as useZoomModal
};
